import { APP_BASE_HREF } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, output, Output, ViewChild } from '@angular/core';
import { ChildComponent } from '../case-detail.component';
import { FormDataService } from '@app/_core/services/form-data.service';
import { AppService } from '@app/_core/services/app.service';
import { FilteredAuditsList } from '@app/_entities/filtered-list';
import { QueuesService } from '@app/_core/services/queues.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { CalendarModule } from 'primeng/calendar';

@Component({
  selector: 'app-disposition-and-notes',
  templateUrl: './disposition-and-notes.component.html',
  styleUrls: ['./disposition-and-notes.component.scss'],
})
export class DispositionAndNotesComponent implements OnInit, ChildComponent, AfterViewInit {

  //DYNAMIC FORM
  @Input() conf: any;
  @Input() caseDetailsConf: any;
  @Input() tabName: any;
  @Input() ReadOnly:boolean
  isEdit: boolean;
  @Output() formDataEmitter = new EventEmitter<any>();
  @Output() formDataHasError = new EventEmitter<any>();
  
  dispositionPayload: any;
  dispositionFields:any=[];
  formData: any = {};
  multiSelectFields: any;
  dropdownOpen: boolean = false;
  user: any;
  company: any;
  activityId: any;
  queueID: any;
  selectedDate:Date=new Date()
  @Output() isDisableSubmitPause:EventEmitter<boolean>=new EventEmitter<boolean>();
  constructor(
    private appService: AppService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private formDataService: FormDataService,
    private queueService: QueuesService,
    private webStorageService: WebStorageService,
    private managerService: ManagerService,
  ) {}
  ngOnInit() {
    this.conf = this.formDataService.getConf(this.caseDetailsConf, this.tabName);
    this.initaliseDisposition();
    console.log("Disposition conf", this.conf);
    this.user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.company = this.webStorageService.getItemFromSessionStorage('company');
    this.appService.activityId.subscribe(value => {
      this.activityId = value;
    });
    this.appService.selectedQueueId.subscribe(queueId => {
      this.queueID = queueId;
    });

    this.initializeFormData();
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    if(this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)){
      this.formDataHasError.emit(true);
    }
    this.emitFormData();
    
  }
  initaliseDisposition()
  {
    this.conf?.Groups?.forEach(fields => {
      fields.Fields?.forEach(field => {
        if(field.Name=="DispositionType")
        {
          field.fieldAttributes?.forEach(attribute => {
             if(attribute.Name=="FieldOptionFields")
              this.dispositionFields = JSON.parse(attribute?.Value);
          });
        }
    });
    });
    //initialise disposition set
    this.dispositionPayload = {
      DispositionType: "",
      UserFollowUp: false, // Schedulefollowup
      CallerFollowUp: false, // ContactRequestedCall
      FollowUpDateTime: null, // UserFollowupDateTime or CallerFollowupDateTime
      offersEnabled: null,
      SendOffer: false,
      OfferToSend: null
    };

  }

  ngAfterViewInit() {}

  editForm() {
    this.isEdit = !this.isEdit;
  }
  checkIsSubOption(fieldObj)
  {
    let subOption=fieldObj.parent?.parentFields?.filter((filter)=>filter.fieldName=="DispositionType");
    return subOption?.length>0 && !fieldObj.Name.toString().toLowerCase().includes('followup')?true:false;
  }
  updateDispositionPayload(fieldObj){
     let fieldName = fieldObj.Name;
     let isSubOption=this.checkIsSubOption(fieldObj);
     if(isSubOption)
     {
        let selectedDisposition=this.dispositionFields.filter((filter)=>filter.DispositionName==fieldName);
        if(selectedDisposition?.length>0) this.dispositionPayload[selectedDisposition[0].DispositionValue?.concat("Disposition")] = this.formData[fieldName] || -1;
     }
     else
     {
     switch(fieldName){
        case "DispositionType":
          this.dispositionPayload.DispositionType = this.formData[fieldName];
          this.dispositionPayload.OfferToSend = null;
          this.dispositionPayload.SendOffer = false;
          break;
        case "Schedulefollowup":
          this.dispositionPayload.CallerFollowUp = this.formData[fieldName] || false;
          if(this.dispositionPayload.CallerFollowUp){
            this.dispositionPayload.UserFollowUp = false;
          }
          break;
        case "ContactRequestedCall":
          this.dispositionPayload.UserFollowUp = this.formData[fieldName] || false;
          if(this.dispositionPayload.UserFollowUp){
            this.dispositionPayload.CallerFollowUp = false;
          }
          break;
        case "Comments":
          this.appService.setDispositionNotes(this.formData[fieldName]);
          break;
        case "UserFollowupDateTime":
          if (this.formData[fieldName]) {
            this.dispositionPayload.FollowUpDateTime = this.formData[fieldName];
            this.dispositionPayload.UserFollowUp = true;
          }
          break;
        case "CallerFollowupDateTime":
          if (this.formData[fieldName]) {
            this.dispositionPayload.FollowUpDateTime = this.formData[fieldName];
          }
          break;
        case "Send an Offer":
          this.dispositionPayload.OfferToSend = this.formData[fieldName] || null;
          this.dispositionPayload.SendOffer = false;
          if(this.dispositionPayload.OfferToSend){
            this.dispositionPayload.SendOffer = true;
          }
          break;
        case "OfferRadioButton":
          this.dispositionPayload.SendOffer = fieldObj.isSelected;
          if(!fieldObj.isSelected){
            this.dispositionPayload.OfferToSend = null;
          }
          break;
     }
    }
     console.log("this.dispositionPayload", this.dispositionPayload);
    //IncompleteDisposition: -1, // Incomplete Call
    //UserFollowUp: false, // Schedulefollowup
    //CallerFollowUp: false, // ContactRequestedCall
    //FollowUpDateTime: null, // UserFollowupDateTime or CallerFollowupDateTime
    //enable or disable Submit and pause
    if(this.dispositionPayload.DispositionType){
      this.managerService.getDispositionReqInteraction(this.dispositionPayload.DispositionType).subscribe((res)=>
      {
        console.log("getDispositionReqInteraction",res);
        this.isDisableSubmitPause.emit(res.Response.Data);
      }
      )
    }
    this.appService.setDispositionPayload(this.dispositionPayload);
    if(this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)){
      this.formDataHasError.emit(true);
    }else{
      this.formDataHasError.emit(false);
    }
  }

  initializeFormData() {
    // Create formData model object from conf fields
    this.conf.Groups.forEach(group => {
        let groupName = group.GroupName?.replaceAll(' ', '');
        if (group.IsMultiple) {

            if(group?.multipleOptions?.optionValues.length>0){
                group.Fields = []; // We should create fields based on group?.multipleOptions?.optionValues items and not display supplied field.
            }

            let groupedData = [];
            // Push existing fields in group. Update: not required
            // group.Fields.forEach((field, i) => {
            //     let obj: any = {};
            //     obj.id = field.fieldID;
            //     obj.name = field.Name;
            //     obj.value = field.value;
            //     groupedData.push(obj);
            // });


            //Create and push new field in conf Fields for each multipleOptions.optionValues
            group?.multipleOptions?.optionValues?.forEach(option => {
                option.items.forEach(item => {
                    let obj: any = {};
                    obj.id = item.id;
                    obj.name = item.name;
                    obj.value = item.value;
                    groupedData.push(obj)

                    let newField = {
                        fieldID: null,
                        Name: '',
                        Label: '',
                        fieldType: 'Input',
                        value: '',
                        fileAttribute: null,
                        isAlphaNumeric: false,
                        isEmail: false,
                        isMobile: false,
                        isRegex: false,
                        isRequired: false,
                        maxLength: null,
                        minLength: null,
                        pattern: '',
                        dateAttribute: null,
                        fieldOptions: []
                    }
            
                    newField.fieldID = item.id;
                    newField.Name = item.name;
                    newField.Label = item.name;
                    newField.value = item.value;
                    newField.isRequired = true;
                    group.Fields.push(newField);
                })
            });

            this.formData[group.GroupName] = groupedData;

        } else {
            group.Fields.forEach(field => {
                field.show = true;
                if(field.fieldType === 'CheckBoxGroup'){
                  // To check the option 
                  this.multiSelectFields.push({ fieldName: field.Name, selectedOptions: [field.value] })
                }
                else{
                  this.formData[field.Name] = field.value;
                }
                if (field.dataSource && field.fieldOptions.length == 0) {
                  this.getData(field);
                }
                if (field.childDataSource && field.fieldOptions.length == 0) {
                  this.getChildData(field);
                }
                if (field.childSourceFromAdmin) {
                  this.getChildDataFromConfiguration(field);
                }
                this.updateDispositionPayload(field);
            });
        }
        this.showAllDependentFields();
    });
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    console.log("formData", this.formData);
    console.log("dispositionPayload", this.dispositionPayload);
  }

  getFormData() {
    let formData = this.formData
    console.log('formData', formData);
  }

  emitFormData() {
    console.log(this.dispositionPayload);
    this.formDataService.updateFormData(this.conf.TabValue, this.formData);
    this.formDataEmitter.emit(this.formData);
  }

  getModel(group, field) {
    let model = "";
    if (group.IsMultiple) {
        model = this.formData[group.GroupName]?.find((f: any) => f.id === field.fieldID)?.value || '';
    } else if(field.fieldType=='DateTimePicker') {

      var date= this.formData[field.Name];

      model=date!=''? this.formatDate(new Date(field.value)):'';

    } 
    {
        model = this.formData[field.Name];
    }
    //console.log("model", field.Name, model);
    return model;
  }
  
  getDateTimePickerModel(field) {
    let model = null;
    if(field.fieldType=='DateTimePicker') 
    return this.formData[field.Name];
  }

  setModel(groupObj, fieldObj, value) {
      if (groupObj.IsMultiple) {
          let field = this.formData[groupObj.GroupName].find((f: any) => f.id === fieldObj.fieldID);
          if(field){
              field.value = value;
          }
      } else {
          this.formData[fieldObj.Name] = value;
      }
      fieldObj.value = value;
  }

  onFormDataChange(groupObj, fieldObj, event, value) {
    let selectedValue = value;
    if (event) {
      selectedValue = event.target.value;
    }

    if(fieldObj.fieldType === "MultiSelect"){
      let checked = event.target.checked;
      let val = this.formData[fieldObj.Name];
      if(checked){
        if(val){
          if(Array.isArray(val)){
            val.push(selectedValue);
            selectedValue = val;
          }else{
            let updatedVal = [];
            updatedVal.push(val);
            updatedVal.push(selectedValue);
            selectedValue = updatedVal;
          }
        }else{
          let updatedVal = [];
          updatedVal.push(selectedValue); 
          selectedValue = updatedVal;
        }
      }else{
        if(Array.isArray(val)){
          selectedValue = val?.filter(function(item) {
            return item !== event.target.value;
          })
        }
      }
      let temp :any = [];
      if(selectedValue.length>0){
        selectedValue?.forEach(item => {
          fieldObj.fieldOptions.forEach(option => {
            if(option.Value == item){
              temp.push(option.Name);
            }
          })
        })
      }
      fieldObj.csv = temp.join();
      //this.dropdownOpen = false;
    }

    this.setModel(groupObj, fieldObj, selectedValue);
    this.emitFormData();
    //this.formDataService.validateField(fieldObj, event.target.value, this.formDataHasError);
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    if(this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)){
      this.formDataHasError.emit(true);
    }
    this.updateDispositionPayload(fieldObj);
    console.log('form data', this.formData);
  }

  onDispositionTypeChange(groupObj, fieldObj, event) {
    console.log("onDispositionTypeChange", fieldObj.Name, event.target.value);
    this.resetFormData(groupObj);
    this.setModel(groupObj, fieldObj, event.target.value);

    // Validate dependent child
    let selectedDispositionOption: any = {};
    fieldObj.fieldOptions.forEach(option => {
     if(option.Value == fieldObj.value){
      selectedDispositionOption = option;
     } 
    })
    this.conf.Groups.forEach(group =>  {
      group.Fields.forEach(field =>  {
        if(field.parent){
          field.parent.parentFields.forEach(item => {
            if(item.fieldName == selectedDispositionOption.Name){
              field.isRequired = true; // make it mandatory
              field.show = true;
            }else{
              field.isRequired = false;
              field.show = false;
              //field.isSelected = false; // Commented out to fix ONV-5706
            }
          })
        }
      })
    })
    console.log('conf', this.conf);
    //------
    this.emitFormData();
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    if(this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)){
      this.formDataHasError.emit(true);
    }
    this.updateDispositionPayload(fieldObj);
    this.showAllDependentFields();
    console.log('form data', this.formData);
  }

  onCheckBoxChange(groupObj, fieldObj, event){
    const target = event.target as HTMLInputElement;

    if (!target || !fieldObj || typeof fieldObj.Name !== 'string') {
      return;
    }

    const isChecked = target.checked;
    const isContactRequestedCallChecked = isChecked && fieldObj.Name === "ContactRequestedCall";
    const isSchedulefollowupChecked = isChecked && fieldObj.Name === "Schedulefollowup";

    // Reset dependent child value
    this.conf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        if(field.Name == "UserFollowupDateTime"){
          field.isRequired = isContactRequestedCallChecked;
        }
    
        if(field.Name == "CallerFollowupDateTime"){
          field.isRequired = isSchedulefollowupChecked;
        }

        if(field.fieldType === 'MultiSelect' && this.isParent(fieldObj, field) && !field.isSelected){
          this.dropdownOpen = false;
          field.value = [];
          this.formData[field.Name] = [];
        }
      })
    })

    groupObj.Fields.forEach(field => {
      if(field.fieldType === 'CheckBox' && field.Name !== fieldObj.Name){
        field.isSelected = false;
        this.formData[field.Name] = false;
        field.children.childFields.forEach(item => {
          this.formData[item.fieldName] = "";
        })
        // /this.formData[field.children.childFields[0].fieldName] = "";
      }
    })

    fieldObj.isSelected = !fieldObj.isSelected;
    
    //Validate child
    groupObj.Fields.forEach(field => {
      fieldObj.children?.childFields.forEach(item => {
        if(field.Name === item.fieldName || item.fieldName.includes(field.Name)){
          field.isRequired = fieldObj.isSelected;
        }
      })
      // if(field.Name === fieldObj.children?.childFields[0].fieldName){
      //   field.isRequired = fieldObj.isSelected;
      // }
    })

    this.setModel(groupObj, fieldObj, fieldObj.isSelected);
    this.emitFormData();
    this.formDataService.validateForm(this.conf, this.formDataHasError);
    if(this.formDataService.anyTabFormDataHasError(this.caseDetailsConf)){
      this.formDataHasError.emit(true);
    }
    this.updateDispositionPayload(fieldObj);
    console.log('form data', this.formData);
  }

  resetFormData(groupObj: any){
    let obj = this.formData;
    let skip = ['Schedulefollowup','CallerFollowupDateTime','UserFollowupDateTime','Comments','ContactRequestedCall'];
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if(!skip.includes(key)){
          obj[key] = null;
        }
      }
    }
    // Clear dependent inner field value in conf object as well
    groupObj.Fields.forEach(field => {
      if(!skip.includes(field.Name)){
        field.value = null;
        this.updateDispositionPayload(field);
      }
    });
    return obj;
  }

  fieldExist(fieldName){
    let exist = false;
    this.conf.Groups.forEach(group =>  {
      group.Fields.forEach(field =>  {
        if(field.Name === fieldName){
          exist = true;
        }
      })
    })
    return exist;
  }

  hideFieldIfExist(fieldName){
    this.conf.Groups.forEach(group =>  {
      group.Fields.forEach(field =>  {
        if(field.Name === fieldName){
          field.hidden = true;
          field.dependent = true;
          field.show = false;
        }
      })
    })
  }

  showAllDependentFields() {
    this.conf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        if (field.parent && field.parentFieldOption) {
          // Is dependent
          field.show = false;
          field.parent.parentFields.forEach(item => {
            let parentField: any = this.getFieldByID(item.fieldID);
            let selectedOption = this.getSelectedOption(parentField, parentField.value);
            //To which option the field is dependent?
            let depends = false;
            field?.parentFieldOption?.parentFieldOption.forEach(item => {
              if (item.fieldOptionID == selectedOption.FieldOptionID) {
                depends = true;
                console.log(field.Name + ' is dependent on ' + parentField.Name + ' : ' + parentField.value);
              }
            });
            if (depends) {
              field.show = true;
            }
          });
        }
        if (field.multipleFieldMappingParent) {
          field.show = false;
          console.log('Hide Mapped Field - ', field.Name + ' - ' + field.fieldID);
        }
        if(field.fieldType === 'CheckBoxGroupWithOther'){
          field.fieldOptions.forEach(option => {
            // check if any field exist with the option.Name, we should not display the field in UI.
            this.hideFieldIfExist(option.Name);
          })
        }
      });
    });
  }

  getFieldByID(fieldID) {
    let targetField = {};
    this.conf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        if (fieldID == field.fieldID) {
          targetField = field;
        }
      });
    });
    return targetField;
  }

  getSelectedOption(field, value) {
    let targetOption: any = {};
    field.fieldOptions.forEach(option => {
      if (option.Value == value) {
        targetOption = option;
      }
    });
    return targetOption;
  }

  onDropDownChange(groupObj, fieldObj, event, value) {
    this.onFormDataChange(groupObj, fieldObj, event, value);
    
    // show/hide dependent fields
    this.showAllDependentFields();
    if (fieldObj.childDataSource) {
      this.getChildData(fieldObj);
    }
    if (fieldObj.childSourceFromAdmin) {
      this.getChildDataFromConfiguration(fieldObj);
    }
  }

  getData(fieldObj) {
    this.formDataService.getData(fieldObj.dataSource+"?activityID="+this.activityId).subscribe(response => {
      //console.log("getData response", response.Response.Data);
      fieldObj.fieldOptions = response;
    });
  }

  getChildData(fieldObj) {
    let childFieldID = fieldObj.children.childFields[0].fieldID;
    let childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value) {
      this.formDataService.getData(fieldObj.childDataSource + fieldObj.value).subscribe(response => {
        console.log('getData response', response.Response.Data);
        childField.fieldOptions = response.Response.Data;
      });
    }
  }

  getChildDataFromConfiguration(fieldObj) {
    let childFieldID = fieldObj.children.childFields[0].fieldID;
    let childField: any = this.getFieldByID(childFieldID);
    childField.fieldOptions = [];
    if (fieldObj.value) {
      let payload={
        queueID:this.queueID,
        activityID:this.activityId,
        fieldID:fieldObj.fieldID,
        fieldName:fieldObj.Name,
        parentValue:fieldObj.value,
        type:"TMScoring"
      }
      this.queueService.getDependantDataSource(payload).subscribe(response => {
           childField.fieldOptions = response.Response.Data;
      });
    }
  }

  anyFieldVisible(groupObj){
    return groupObj.Fields.find(field => field.show) !== undefined;
  }

  isParent(parentField, childField){
    let isParent = false;
    childField.parent?.parentFields.forEach(item => {
      if(item.fieldName === parentField.Name || item.fieldName.includes(parentField.Name)){
        isParent = true;
      }
    })
    return isParent;
  }

  toggleDropdown(event: Event) {
    this.dropdownOpen = !this.dropdownOpen;
    event.stopPropagation();
  }


  calSelectedDate(group, fieldInner, $event, value)
  {
    this.onFormDataChange(group, fieldInner,{target: {value:this.formatDate($event)}}, value)
  }

  formatDate(value)
  {
    const year=value.getFullYear();
    const month=(value.getMonth()+1).toString().padStart(2,'0');
    const day=value.getDate().toString().padStart(2,'0')
    const hour=value.getHours().toString().padStart(2,'0')
    const minutes=value.getMinutes().toString().padStart(2,'0')
    const seconds=value.getSeconds().toString().padStart(2,'0')

    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`
  }
  onCalendarDateSelected(group: any, field: any, event: any) {
    field.value = event.date;
    this.onFormDataChange(group, field, null, event.date);
    this.appService.setDateTimePickerData({ 
        tabName:"disposition",
        fieldName: field.Name,
        caseId: null,
        dateValue: event.date,
        convertedDateValue: new Date(event.date)  
    });
  }
}
